var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIthrottir = function SvgIthrottir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ithrottir_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ithrottir_svg__b)",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 1.306a14.694 14.694 0 1 0 0 29.388 14.694 14.694 0 0 0 0-29.388v0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.944 22.21 9.45 14.502 16 9.741l6.55 4.762-2.495 7.706h-8.11ZM21.618 2.418 16 6.204l-5.618-3.786M19.395 30.3l2.794-5.703 6.379-.98M30.647 17.187 26.17 12.73l.96-6.32M16 6.204v3.537M22.55 14.503l3.62-1.774M1.353 17.187 5.83 12.73l-.96-6.32M9.45 14.503 5.83 12.73M20.055 22.21l2.133 2.387M12.605 30.3l-2.793-5.703-6.38-.98M11.944 22.21l-2.132 2.387"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ithrottir_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ithrottir_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgIthrottir;